// src/routesConfig.js
import Home from "./routes/home/Home.js";
import Proyectos from "./routes/proyectos/Proyectos";
import Contacto from "./routes/contacto/Contacto";
import Privacy from "./routes/legal/pdPrivacidad/privacy.js";
import Cookies from "./routes/legal/udCookies/cookies.js";
import ErrorPage from "./routes/errorPage/Error";

export const routesConfig = [
  { path: "/", element: <Home /> },
  { path: "/proyectos", element: <Proyectos /> },
  { path: "/contact", element: <Contacto /> },
  { path: "/legal/privacidad", element: <Privacy /> },
  { path: "/legal/cookies", element: <Cookies /> },
  // El 404 NO debe ir al sitemap
  { path: "*", element: <ErrorPage />, excludeFromSitemap: true }
];